import ConfigurationField from '../ConfigurationField/ConfigurationField';
import { ConfigurationDataType, ConfigurationFieldType } from '@ydistri/api-sdk';
import React from 'react';
import { ConfigurationSwitchUIConfiguration } from '@ydistri/ds';

interface CategoryEnableSwitchProps {
  categoryId: number;
  disabled?: boolean;
}

const typeConfiguration: ConfigurationSwitchUIConfiguration = {
  size: 'small',
  hideOverwrittenIcon: true,
};

/**
 * A switch to enable/disable a category in the category tree.
 * Displayed in a small form and without the overwritten icon.
 * @param categoryId the category id
 * @param disabled if the switch is disabled
 */
export const EnableCategoryField: React.FC<CategoryEnableSwitchProps> = ({
  categoryId,
  disabled,
}) => {
  return (
    <ConfigurationField
      skuTypeColumn={null}
      forcedCategoryId={categoryId}
      fieldType={ConfigurationFieldType.CatEnableCategory}
      dataType={ConfigurationDataType.CheckBox}
      noAdditionalSpace={true}
      padding="0"
      autoHeight={true}
      disabled={disabled}
      typeConfiguration={typeConfiguration}
    />
  );
};

export default EnableCategoryField;
